<template>
  <div class="card-top-item">
    <div class="left-info">
      <h2 class="mg0 mgr12" style="display: inline-block">{{cardDetail.companyName || '小店商家名'}}</h2>
      <template v-if="cardDetail.vipMark">
        <el-image class="mgr12" style="width: 28px; height: 14px; margin-left: 10px"  :src="vip"></el-image>
      </template>
      <template v-if="isDistributor || isProductDetail || isUnLoginShare">
        <el-tag
            class="mgr12"
            v-if="typeMapText[cardDetail.type]"
            :type="typeMapText[cardDetail.type]['type']"
            size="small"
        >
          {{ typeMapText[cardDetail.type].text }}
        </el-tag>
      </template>
      <template v-if="cooperationDetail.cooperationMode.length">
        <el-tag
          class="mgr12"
          size="small"
          v-for="tag in cooperationDetail.cooperationMode"
          :key="tag"
          :type="tag == 1 ? 'success' : ''"
        >{{cooperationMode_map[tag]}}</el-tag>
      </template>
      <el-popover
          placement="bottom"
          title=""
          width="200"
          trigger="hover"
      >
        <div class="text-center" v-loading="loading">
          <div>
            <img width="144px" :src="wxCodeUrl" alt="" />
          </div>
          <div class="text-999 mgt20">微信扫一扫，手机看好货</div>
        </div>
        <div slot="reference" class="visitorMin" @mouseenter="getWxCodeUrl(cardDetail.companyId)" v-if="isDistributor || isProductDetail || isUnLoginShare">
          <img :src="iconImg" width="16" />
          <span class="mgl4">手机看货</span>
        </div>
      </el-popover>
    </div>
    <div class="right-info" v-if="isSupplier">
        <el-link style="margin-right: 15px"  @click="showDisplayRackClassifyDrawer()">
            <i class="el-icon-setting"></i>展架分类设置
        </el-link>
      <el-link style="margin-right: 15px" @click="jump('price')">
        <i class="el-icon-caiwu1"></i>分销价格设置
      </el-link>
      <el-link @click="jump('goods')">
        <i class="el-icon-sold-out"></i>按分销商配置可售商品
      </el-link>
    </div>
    <DisplayRackClassifyDrawer 
        v-if="displayRackClassifyDrawerVisible" 
        :visible="displayRackClassifyDrawerVisible"
        @close="displayRackClassifyDrawerVisible=false">
    </DisplayRackClassifyDrawer>
  </div>
</template>

<script>
import DisplayRackClassifyDrawer from './DisplayRackClassifyDrawer/index.vue'
import vip from '@/assets/images/vip.png'
import {generateQrCodeUrl} from "@api/distributor";
import { get } from 'lodash'
import supplier_dictionary from "@/dictionary/supplier";
import visitorIcon from '@/assets/vistitorMin.svg'

export default {
  components: {
    DisplayRackClassifyDrawer,
  },
  props: {
    identity: {
      type: String,
      default: 'supplier'
    },
    showMin: {
      type: Boolean,
      default: false
    },
    cardDetail: {
      type: Object,
      default: () => {
        return {
          companyName: '',
          majorCategory: '',
          wx: '',
          phone: '',
          vipMark: false,
          distributionPlatform: [],
          majorPlatform: [],
          video: [],
          picture: [],
          summary: ''
        }
      }
    },
    cooperationDetail: {
      type: Object,
      default: () => {
        return {
          cooperationMode: [], // 合作模式 1: 一件代发、 2:批量采购 - 可多选，逗号分隔
          deliveryTime: 1
        }
      }
    },
  },
  data() {
    return {
      ...supplier_dictionary,
      vip,
      cooperationMode_map: {
        1: '一件代发',
        2: '批量采购'
      },
      wxCodeUrl: '',
      loading: false,
      iconImg: visitorIcon,
      typeMapText: {
        21: {
          text: '已合作',
          type: 'success'
        },
        22: {
          text: '未合作',
          type: 'info'
        }
      },
        displayRackClassifyDrawerVisible: false,
    };
  },
  computed: {
    isSupplier() {
      return this.identity === 'supplier'
    },
    isDistributor() {
      // 分销商端
      return this.identity === 'distributor'
    },
    isProductDetail() {
      // 分销商
      return this.identity === 'productDetail'
    },
    isUnLoginShare() {
      // 未登录状态
      return this.identity === 'unLoginShare'
    },
    isScm() {
      return window.location.host === 'scm.superboss.cc'
    }
  },
  watch: {
    // cardDetail(newVal, oldVal) {
    //   this.getWxCodeUrl(newVal.companyId)
    // }
  },
  methods: {
    async getWxCodeUrl(supplierCompanyId) {
      this.loading = true;

      // 优先从缓存获取
      let url = sessionStorage.getItem('WxCodeUrlIsHyaline');
      if(!url){
        let res = await generateQrCodeUrl({
          path: 'supplier/list/index',
          params: JSON.stringify({
            supplierCompanyId,
            fromLoginIdentity: 1
          }),
          envVersion: 'release', // release -正式版 trial - 体验版 develop-开发版
          width: 144,
          isHyaline: true,
        })
        url = get(res, 'data', '');
        // 缓存二维码URL，避免重复生成超过微信调用限制
        if (url) {
          sessionStorage.setItem('WxCodeUrlIsHyaline', url);
        }
      }
      this.wxCodeUrl = url;
      this.loading = false;
    },
    jump(type) {
      const pathMap = {
        price: '/supplier/management/price',
        goods: '/supplier/management/rules'
      }
      this.$router.push({
        path: pathMap[type]
      })
    },
      showDisplayRackClassifyDrawer () {
        this.displayRackClassifyDrawerVisible = true;
    }
  },
};
</script>

<style scoped>
.card-top-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left-info{
  display: flex;
  align-items: center;
}
.visitorMin {
  border: 1px solid #DFDFDF;
  padding: 6px 12px;
  display: flex;
  line-height: 1;
  align-items: flex-end;
}
</style>
